import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { DictionaryDeposit } from './../../models';

export function useDirpAuthors() {
  return useAutocompleteSource<DictionaryDeposit>({
    url: `${EvidenceAPI.DICTIONARY_DIRP_AUTHORS}/autocomplete`,
  });
}
